<template>
  <div class="contain">
    <div class="title">
      {{dataTitle}}
    </div>
    <div class="contain-info">
      <div class="video-info">
        <div class="video-info-right">
          <div class="video-info-right-info">
<!--            <img src="@/assets/img/vir/vir2.png" alt="">-->
            本产品基于云计算、大数据、人工智能等技术，为职业教育院校提供跨平台、多终端、泛在式虚拟仿真实训教学管理及资源共享平台。平台资源可开放给校外用户，为校园服务社会、学生终身学习提供一体化解决方案。
          </div>
        </div>
        <div class="video-info-left">
          <img src="@/assets/img/vir/vir1.png" alt="">
        </div>
      </div>
    </div>
    <div class="contain-bottom">
      <div class="contain-bottom-content" v-for="(items,index) in dataList">
        <div class="contain-bottom-content-img">
          <img :src="items.logo" alt="">
        </div>
        <div class="contain-bottom-content-title">
          <div>{{items.title}}</div>
        </div>
        <div class="contain-bottom-content-info">
<!--          <img :src="items.src" alt="">-->
          {{items.content}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 虚拟仿真
  name: "Vir.vue",
  components: {
  },
  data () {
    return {
      dataTitle:'虚拟仿真共享平台',
      dataList:[
        {
          title:'虚拟仿真',
          logo:require("../assets/img/vir/vir3.png"),
          // src:require("../assets/img/vir/vir6.png")
          content:'基于3D图像引擎、虚拟现实等技术，为学生提供理实一体、虚实结合的教学实训环境，解决实训教学过程中高投入、高损耗、高风险及难实施、难观摩、难再现的“三高三难”痛点和难点。'
        },
        {
          title:'数字画像',
          logo:require("../assets/img/vir/vir4.png"),
          // src:require("../assets/img/vir/vir7.png")
          content: '具备虚拟仿真实训教学过程的监控分析功能，能够实时跟踪采集虚拟仿真实训“教、学、考、练、评”过程的数据，利用人工智能手段对实训过程大数据进行挖掘分析并画像，为虚拟仿真实训教学质量的诊断改进提供依据。'
        },
        {
          title:'智能泛在',
          logo:require("../assets/img/vir/vir5.png"),
          // src:require("../assets/img/vir/vir8.png")
          content: '虚拟仿真实训资源可在不同的硬件平台上无缝展示和交互。获得授权的校内外用户均能通过台式或便携式个人计算机（PC）、手机、平板电脑（PAD）、桌面式一体机等终端设备，在任意地点、任意时间访问使用虚拟仿真实训资源。'
        }
      ]
    }
  },
  methods: {

  },

}
</script>

<style lang="scss" scoped>
@import '../assets/css/Vir.scss';
</style>


